// extracted by mini-css-extract-plugin
module.exports = {"pageSegment":"styles_pageSegment__23qkb","title":"styles_title__pTq3_","spin":"styles_spin__3WrJA"};